import { LoadBookingInfo } from "@vahak/core/dist/custom-types";

export function getBookingMeta(info: { isTapNgo?: boolean; isSpot?: boolean }, obj: any) {
    const { isTapNgo } = info;
    if (isTapNgo) {
        return obj["tap_n_go_info"] as LoadBookingInfo;
    } else {
        return obj["spot_load_info"] as LoadBookingInfo;
    }
}
